import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { clearStorage } from "../store";

const useAutoLogout = (timeout: number = 30 * 60 * 1000) => {
  const navigate = useNavigate();
  const timer = useRef<number>();
  const dispatch = useDispatch();

  const resetTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = window.setTimeout(() => {
      toast.success("You have been logged out due to inactivity.");
      dispatch(clearStorage());
      navigate("/");
    }, timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  return null;
};

export default useAutoLogout;
